const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.927,
    height: 45.813,
    viewBox: "0 0 56.927 45.813",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1319.281 832.717a2.024 2.024 0 0 1-1.438-.6l-4.662-4.661-4.661 4.661a2.033 2.033 0 0 1-2.875-2.874l6.1-6.1a2.033 2.033 0 0 1 2.875 0l6.1 6.1a2.033 2.033 0 0 1-1.437 3.47z",
    style: {
      fill: "#809eb2"
    },
    transform: "translate(-1284.718 -801.136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.181 846.949a2.033 2.033 0 0 1-2.033-2.033v-20.331a2.034 2.034 0 0 1 4.067 0v20.331a2.033 2.033 0 0 1-2.034 2.033z",
    style: {
      fill: "#809eb2"
    },
    transform: "translate(-1284.718 -801.136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.763 840.442h-2.846a12.2 12.2 0 1 1 0-24.4h.056a16.194 16.194 0 0 1 29.235-8.246 2.033 2.033 0 0 1-3.283 2.4 12.132 12.132 0 0 0-21.942 7.2v.677a2.033 2.033 0 0 1-2.033 2.034h-2.033a8.132 8.132 0 1 0 0 16.264h2.846a2.033 2.033 0 1 1 0 4.066z",
    style: {
      fill: "#809eb2"
    },
    transform: "translate(-1284.718 -801.136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1329.446 840.442h-3.388a2.033 2.033 0 0 1 0-4.066h3.388a8.132 8.132 0 0 0 0-16.264h-2.033a2.034 2.034 0 0 1 0-4.067h2.033a12.2 12.2 0 1 1 0 24.4z",
    style: {
      fill: "#809eb2"
    },
    transform: "translate(-1284.718 -801.136)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudicon);
export default __webpack_public_path__ + "static/media/cloud.icon.7f232f730f70d916bcae72ff3b87b0c2.svg";
export { ForwardRef as ReactComponent };